/** localStorage payload version — bump if shape changes */
export const INBOX_LAYOUT_STORAGE_KEY = "sample-ui:chat-inbox:column-widths:v1";

/** Default column widths (px) */
export const INBOX_COLUMN_DEFAULTS = {
  left: 300,
  right: 320,
};

/** Hard limits (px). Center column is flex-1 with its own minimum — see CENTER_MIN_PX */
export const INBOX_COLUMN_LIMITS = {
  left: { min: 220, max: 560 },
  right: { min: 260, max: 520 },
};

/** Minimum width reserved for the chat thread so it stays usable */
export const INBOX_CENTER_MIN_PX = 300;

/** Visual / hit target width for each vertical grip (px) */
export const INBOX_SPLITTER_WIDTH_PX = 8;

/** Step size when resizing with keyboard (px) */
export const INBOX_KEYBOARD_NUDGE_PX = 16;
